module.exports = __webpack_public_path__ + "img/icon-transfer.e4ff9f15.png";